export default "__VITE_ASSET__BdX8iMBU__"